// extracted by mini-css-extract-plugin
export var brand = "NavBrand-module--brand--2H9M-";
export var brandDropdownButton = "NavBrand-module--brand-dropdown-button--3O-tn";
export var onClickOutside = "NavBrand-module--on-click-outside--36VW0";